import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import classNames from 'classnames';
import { LinkContext } from '../../../context';
import { CloudinaryImage } from '../../cloudinary-image';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MegaMenuFeaturedItem = _ref => {
  let {
    parentCategory,
    feature
  } = _ref;
  const Link = useContext(LinkContext);
  return /*#__PURE__*/_jsxs(Stack, {
    sx: {
      width: 'size-xl',
      maxHeight: 'size-full',
      display: ['none', null, null, 'initial']
    },
    className: classNames('sc-slot', "sc-slot-".concat(parentCategory)),
    gap: "spacing-sm",
    shouldWrapChildren: false,
    as: feature.link ? props => {
      var _feature$link;

      return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
        to: feature === null || feature === void 0 ? void 0 : (_feature$link = feature.link) === null || _feature$link === void 0 ? void 0 : _feature$link.url,
        onClick: () => trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, "".concat(parentCategory, " - ").concat(feature.title)),
        "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Link"
      }));
    } : 'div',
    "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Stack",
    children: [feature.image && /*#__PURE__*/_jsx(CloudinaryImage, {
      ratio: "1",
      imageSetOrImage: {
        type: 'SQUARE',
        url: feature.image.src,
        alt: feature.image.description
      },
      sizes: 214,
      "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_CloudinaryImage"
    }), /*#__PURE__*/_jsxs(Stack, {
      shouldWrapChildren: false,
      gap: "spacing-sm",
      "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Stack_Stack",
      children: [/*#__PURE__*/_jsxs(Stack, {
        shouldWrapChildren: false,
        "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Stack_Stack_4",
        children: [feature.title && /*#__PURE__*/_jsx(Text, {
          tone: "strong",
          lineHeight: "base",
          "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Text",
          children: feature.title
        }), feature.body && /*#__PURE__*/_jsx(Text, {
          lineHeight: "base",
          "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Text_6",
          children: feature.body
        })]
      }), feature.link && /*#__PURE__*/_jsx(Text, {
        lineHeight: "base",
        sx: {
          textDecoration: 'underline'
        },
        "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Text_7",
        children: feature.link.label
      })]
    })]
  });
};